import React from 'react';
import { Link } from 'react-router-dom';
import SparkleIcon from 'assets/images/ambassador/sparkle-small.svg';
import { AMBASSADOR_INVITATION_PATH } from 'services/ambassador';
import { track } from 'services/tracking';
import PoppinsFont from 'styles/poppins_font';
import { Container } from './styles';

const TopBannerAmbassadorInvite: React.FC = () => (
  <Container className="fixed-top w-100 d-print-none">
    <PoppinsFont />
    <Link
      className="invite-link"
      to={AMBASSADOR_INVITATION_PATH}
      onClick={() => track('embaixador.clicou_faixa_convite')}
    >
      <img src={SparkleIcon} alt="" />
      <span>
        Uma oportunidade especial para um cliente especial:{' '}
        <strong>SEJA EMBAIXADOR DO CONLICITAÇÃO</strong>
      </span>
      <img className="sparkle-mirrored" src={SparkleIcon} alt="" />
    </Link>
  </Container>
);

export default TopBannerAmbassadorInvite;
